
export default {
    // 园区总览信息
    overviewInfo: {
        area: 22344.32,
        useArea: 15435.43,
        people: 23243,
        entCount: 834
    },
    // 区域面积信息
    regionArea: [{
        id: 'A',
        name: 'A 区111',
        value: 1200
    }, {
        id: 'B',
        name: 'B 区',
        value: 2600
    }, {
        id: 'C',
        name: 'C 区',
        value: 1800
    }],
    // 区域企业统计
    regionEnt: [{
        id: 'A',
        name: 'A 区',
        entCount: 224,
        ent: {
            '高新企业': 23,
            '瞪羚企业': 32,
            '明星企业': 12,
            '规上企业': 43,
            '上市企业': 31,
            '独角兽': 34,
        }
    }, {
        id: 'B',
        name: 'B 区',
        entCount: 561,
        ent: {
            '高新企业': 41,
            '瞪羚企业': 37,
            '明星企业': 23,
            '规上企业': 63,
            '上市企业': 44,
            '独角兽': 51,
        }
    }, {
        id: 'C',
        name: 'C 区',
        entCount: 232,
        ent: {
            '高新企业': 12,
            '瞪羚企业': 22,
            '明星企业': 5,
            '规上企业': 13,
            '上市企业': 11,
            '独角兽': 10,
        }
    }],
    // 园区信息
    parkInformation: {
        parkingCount: 634,
        people: 23243,
        air: '优',
        temperature: 27,
        traffic: '拥堵',
        weather: '晴转多云'
    },
    // 园区事件
    parkEvents: [
        {
            'content': 'B12 附近发生小车刮擦事件',
            'time': '2021-04-21 12:32:34',
            'isAlarm': false
        },
        {
            'content': 'B20 路段拥堵,行人较多',
            'time': '2021-04-25 14:32:34',
            'isAlarm': false
        },
        {
            'content': '地铁口车辆拥堵,拥堵指数高',
            'time': '2021-04-25 18:32:34',
            'isAlarm': false
        },
        {
            'content': 'B12 十字路口发生人员争执',
            'time': '2021-04-30 08:42:14',
            'isAlarm': false
        },
        {
            'content': '金海豚附近发生行人和非机动车相撞事件',
            'time': '2021-04-30 12:12:04',
            'isAlarm': true
        },
        {
            'content': '地铁口监控设备异常',
            'time': '2021-04-30 15:12:54',
            'isAlarm': false
        },
        {
            'content': '地铁口路段拥堵',
            'time': '2021-04-30 18:02:35',
            'isAlarm': false
        },
        {
            'content': '地铁口路段拥堵,需要疏导',
            'time': '2021-04-30 19:42:53',
            'isAlarm': true
        }
    ],
    carPaths: {
        startTime: '2021-05-11 08:00:00',
        endTime: '2021-05-11 08:05:00',
        range: 'LOOP_STOP',
        paths: [{
            carType: '1',
            id: 'car-001',
            carNumber: '闽D 23453',
            type: '的士',
            rotationY: 1 / 4 * Math.PI,
            pathShow: false,
            content: '满载',
            normal: false,
            carPosition: [118.03945677834663, 24.61837131820503, 22.4680712822181],
            datas: [{
                time: '2021-05-11 08:00:00',
                position: [118.03945677834663, 24.61837131820503, 22.4680712822181],
            }, {
                time: '2021-05-11 08:01:30',
                position: [118.04092373957738, 24.616642100806352, 21.19188106424331],
            }, {
                time: '2021-05-11 08:01:40',
                position: [118.04092373957738, 24.616642100806352, 21.19188106424331],
            }, {
                time: '2021-05-11 08:02:00',
                position: [118.04126886500343, 24.616231614010214, 20.886721923818563],
            }, {
                time: '2021-05-11 08:02:25',
                // position: [118.04200052642364, 24.615299764050988, 19.97210720883456],
                position: [118.04198647572065, 24.615287484212438, 19.980988487262948]
            }],
        }, {
            carType: '1',
            id: 'car-002',
            carNumber: '闽D 34563',
            rotationY: -3 / 4 * Math.PI,
            pathShow: false,
            type: '私家车',
            content: '图扑软件',
            normal: true,
            carPosition: [118.04246940911084, 24.614981617466707, 19.703326279372618],
            datas: [{
                time: '2021-05-11 08:00:00',
                position: [118.04246940911084, 24.614981617466707, 19.703326279372618],
            }, {
                time: '2021-05-11 08:00:20',
                position: [118.04193418832517, 24.615521783642222, 20.060573966432887],
            }, {
                time: '2021-05-11 08:00:40',
                position: [118.0412801267723, 24.616285543465995, 20.82423423652462],
            }, {
                time: '2021-05-11 08:00:55',
                position: [118.0412801267723, 24.616285543465995, 20.82423423652462],
            },

            {
                time: '2021-05-11 08:01:05',
                position: [118.04115787833659, 24.616405855426233, 20.983593225896374],
            },
            {
                time: '2021-05-11 08:01:08',
                position: [118.04107955780474, 24.616464639449287, 20.926888791213372],
            },
            {
                time: '2021-05-11 08:01:10',
                position: [118.04100910181188, 24.61646298576897, 21.08821079332904],
            },
            {
                time: '2021-05-11 08:01:15',
                position: [118.04097028677937, 24.616423118844413, 21.021404221032338],
            },

            {
                time: '2021-05-11 08:01:25',
                position: [118.04091806409338, 24.616355526288853, 21.061362192600242],
            }, {
                time: '2021-05-11 08:01:50',
                position: [118.04053112320369, 24.615752564509055, 21.65073996949241],
            }, {
                time: '2021-05-11 08:02:25',
                position: [118.0402630997849, 24.61519697844411, 22.15225978280558],
            }],
        }, {
            carType: '2',
            id: 'car-003',
            carNumber: '闽D 44456',
            type: '的士',
            rotationY: -3 / 4 * Math.PI,
            pathShow: false,
            content: '空闲',
            normal: true,
            carPosition: [118.04209171279473, 24.615385605430006, 19.973322989019344],
            datas: [{
                time: '2021-05-11 08:00:00',
                position: [118.04209171279473, 24.615385605430006, 19.973322989019344],
            }, {
                time: '2021-05-11 08:00:30',
                position: [118.04132470915151, 24.616270193251335, 20.78285641198586],
            }, {
                time: '2021-05-11 08:00:55',
                position: [118.04132470915151, 24.616270193251335, 20.78285641198586],
            }, {
                time: '2021-05-11 08:01:20',
                position: [118.04099183536252, 24.61669773651903, 21.084186560884042],
            }, {
                time: '2021-05-11 08:02:25',
                position: [118.04068081351399, 24.617049323498325, 21.392780648866903],
            }, {
                time: '2021-05-11 08:03:25',
                position: [118.03949230513057, 24.618357224374517, 22.453692070646582],
            }],
        }, {
            carType: '3',
            id: 'car-004',
            carNumber: '闽D 66666',
            type: '私家车',
            rotationY: -3 / 4 * Math.PI,
            pathShow: false,
            content: 'Hightopo',
            normal: true,
            carPosition: [118.04220004004014, 24.615265622175308, 19.916131650308827],
            datas: [{
                time: '2021-05-11 08:00:00',
                position: [118.04220004004014, 24.615265622175308, 19.916131650308827],
            }, {
                time: '2021-05-11 08:00:45',
                position: [118.04135921088995, 24.616239283568802, 20.736811537890254],
            }, {
                time: '2021-05-11 08:00:55',
                position: [118.04135921088995, 24.616239283568802, 20.736811537890254],
            }, {
                time: '2021-05-11 08:01:30',
                position: [118.04096872194265, 24.616696564713425, 21.10067602450364],
            }, {
                time: '2021-05-11 08:02:25',
                position: [118.04059185502824, 24.61714594951483, 21.46073885467585],
            }, {
                time: '2021-05-11 08:03:15',
                position: [118.03955089162552, 24.61835300564191, 22.405185980528323],
            }],
        }, {
            carType: '4',
            id: 'car-005',
            carNumber: '闽D 76A66',
            type: '公交车',
            rotationY: 1 / 4 * Math.PI,
            pathShow: false,
            content: '232',
            normal: true,
            carPosition: [118.03874927598696, 24.619168844665783, 20.454578726649146],
            datas: [{
                time: '2021-05-11 08:00:00',
                position: [118.03874927598696, 24.619168844665783, 20.454578726649146],
            }, {
                time: '2021-05-11 08:00:45',
                position: [118.03914018499994, 24.618694751894704, 21.953244267854192],
            }, {
                time: '2021-05-11 08:00:55',
                position: [118.03914018499994, 24.618694751894704, 21.953244267854192],
            }, {
                time: '2021-05-11 08:01:20',
                position: [118.03943090253898, 24.618354137433734, 22.39116642804828],
            }, {
                time: '2021-05-11 08:02:25',
                position: [118.0408957817589, 24.61663707912554, 21.128588655281547],
            }, {
                time: '2021-05-11 08:02:45',
                position: [118.0408957817589, 24.61663707912554, 21.128588655281547],
            }, {
                time: '2021-05-11 08:03:05',
                position: [118.04126886500343, 24.616231614010214, 20.886721923818563],
            }, {
                time: '2021-05-11 08:04:15',
                position: [118.04199463155133, 24.61532690397307, 20.09501713606902],
            }],
        }]
    }
};